import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Globe } from "@/components/Globe";
import { Reveal } from "@/components/Reveal";

const Block = ({ label, title, children }) => (
  <Reveal className="border-b-2 border-[#f4f4f2] px-1 py-8 md:px-4">
    <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.22em] text-[#a8a8a4]">
      {label}
    </span>
    <h2 className="font-display mt-3 text-xl uppercase tracking-tight md:text-2xl">{title}</h2>
    <div className="mt-4 space-y-2 text-sm leading-relaxed text-[#f4f4f2] md:text-base">
      {children}
    </div>
  </Reveal>
);

export const Impressum = () => {
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f4f4f2]" data-testid="impressum-page">
      <header className="border-b-2 border-[#f4f4f2] py-5">
        <div className="mx-auto flex max-w-[920px] items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-3" data-testid="impressum-logo-link">
            <Globe spin className="h-[30px] w-[30px] text-[#f4f4f2]" />
            <span className="font-mono2 text-xs font-bold uppercase tracking-[0.18em] md:text-sm">
              Housegemacht
            </span>
          </Link>
          <Link
            to="/"
            data-testid="impressum-back-link"
            className="border-2 border-[#f4f4f2] px-4 py-2 font-mono2 text-[11px] font-bold uppercase tracking-[0.12em] transition-colors duration-200 hover:bg-[#f4f4f2] hover:text-[#0a0a0a]"
          >
            Zurück
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-[920px] px-6 pb-20 pt-14 md:pt-20">
        <Reveal>
          <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.22em] text-[#a8a8a4] md:text-xs">
            Rechtliches
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display mt-4 border-b-2 border-[#f4f4f2] pb-8 text-[clamp(2.6rem,10vw,5.5rem)] uppercase leading-[0.92] tracking-tight">
            Impressum
          </h1>
        </Reveal>

        <Block label="§ 5 DDG" title="Angaben gemäß § 5 DDG">
          <p className="font-semibold">Housegemacht</p>
          <p>Nachtigallenweg 26</p>
          <p>50829 Köln</p>
          <p>Deutschland</p>
        </Block>

        <Block label="Vertretung" title="Vertreten durch die Geschäftsführer">
          <p>Younes El Omari</p>
          <p>Oren Simons</p>
        </Block>

        <Block label="Kontakt" title="Kontakt">
          <p>
            E-Mail:{" "}
            <a
              href="mailto:Housegemachtevents@gmail.com"
              data-testid="impressum-email-link"
              className="underline underline-offset-4 transition-colors duration-200 hover:text-[#a8a8a4]"
            >
              Housegemachtevents@gmail.com
            </a>
          </p>
        </Block>

        <Block label="Verantwortlich" title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
          <p>Younes El Omari &amp; Oren Simons</p>
          <p>Nachtigallenweg 26, 50829 Köln</p>
        </Block>

        <Block label="Haftung" title="Haftung für Inhalte">
          <p>
            Die Inhalte dieser Seite wurden mit großer Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich.
          </p>
        </Block>

        <Block label="Links" title="Haftung für Links">
          <p>
            Diese Seite enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
            oder Betreiber der Seiten verantwortlich.
          </p>
        </Block>

        <Block label="Urheberrecht" title="Urheberrecht">
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
            dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
            der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
            Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </Block>

        <Reveal delay={0.1}>
          <p className="font-mono2 mt-10 text-[11px] font-bold uppercase tracking-[0.18em] text-[#a8a8a4]">
            © 2026 Housegemacht — The Home of House
          </p>
        </Reveal>
      </main>
    </div>
  );
};
